import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/auth-guard/auth-guard-service';
import { MSALAuthGuardService } from './services/auth-guard/msalauth-Guard-service';
import { PrenavbarComponent } from './prelogin/prenavbar/prenavbar.component';
import { PreauthGuard } from './services/auth-guard/preauth.guard';
import { MaintenanceComponent } from './shared/component/maintenance/maintenance.component';
import { UnauthorizedPageComponent } from './unauthorized-page.component';
import { PageNotFoundComponent } from './page-not-found.component';
import { LayoutComponent } from './layout.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,   // <--- new shell instead of AppComponent
    children: [
      {
        path: 'maintenance',
        canActivate: [MSALAuthGuardService, PreauthGuard],
        component: MaintenanceComponent
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./postlogin/postlogin.module').then((m) => m.PostloginModule),
        canActivate: [MSALAuthGuardService, AuthGuardService],
      },
      {
        path: 'prelogin',
        canActivate: [MSALAuthGuardService, PreauthGuard],
        component: PrenavbarComponent,
      },
      {
        path: 'unauthorized',
        component: UnauthorizedPageComponent,
      }
    ]
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
